import React from "react";
import {InventoryTitles} from "../../OrdersListUIHelpers";

export function InventoryNameFormatter(cell, row){
    return(
        <span className={'label label-lg label-light-primary label-inline'}>
            {InventoryTitles[row.inventory]}
        </span>
    )
}